import { merge } from 'lodash-es';
import type { Simplify } from 'type-fest';

const DEFAULT_PLUMA_COMPONENT_FLAGS: PlumaComponentFlags = Object.freeze({
	unsafe_useLegacyButton: false,
});

export type PlumaComponentFlags = Simplify<{
	unsafe_useLegacyButton: boolean;
}>;

export type PlumaContextValue = Simplify<{
	componentFlags: PlumaComponentFlags;
}>;

const DEFAULT_PLUMA_CONTEXT_VALUE: PlumaContextValue = Object.freeze({
	componentFlags: DEFAULT_PLUMA_COMPONENT_FLAGS,
});

export function makePlumaContextValue(props?: Partial<PlumaContextValue>): PlumaContextValue {
	return merge({}, DEFAULT_PLUMA_CONTEXT_VALUE, props);
}
